import React from 'react';
import { RecoilRoot } from 'recoil';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { Slide } from '@mui/material';
import Main from 'pages/Main';
import NewPassword from 'pages/NewPassword';
import Post from 'pages/Post';
import ResetPassword from 'pages/ResetPassword';
import Modify from 'pages/Modify';
import Comment from 'pages/Comment';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App = () => {
  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider
          maxSnack={2}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          TransitionComponent={Slide}
          autoHideDuration={1500}
        >
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<Main />} />
              <Route path='/modify' element={<Modify />} />
              <Route path='/recent/post' element={<Post />} />
              <Route path='/recent/comment' element={<Comment />} />
              <Route path='/password/setting' element={<NewPassword />} />
              <Route path='/password/reset' element={<ResetPassword />} />
            </Routes>
          </BrowserRouter>
        </SnackbarProvider>
      </QueryClientProvider>
    </RecoilRoot>
  );
};

export default App;
